
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { NavBar } from '@/components'
import store from '../store'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    NavBar
  }
})

export default class CallTranscriptView extends Vue {
  data () {
    return {
      isLoading: false,
      isLoadingProcessing: false,
      chats: [],
      callHistory: [],
      loggedUserId: null,
      callId: null,
      currOtherUserId: null,
      callUsers: [],
      callData: null,
      processedComplete: 0,
      requestProcessingInterval: null
    }
  }

  mounted () {
    this.callId = this.$route.params.callId
    this.getCurrUserId()
    this.init()
  }

  async init () {
    // await this.getCallUsers()
    await this.getCallData()
    await this.getCallHistory()
  }

  getCurrUserId () {
    this.loggedUserId = store.getters.getLoggedUserId
  }

  async getCallHistory () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getCallHistories/${this.callId}`))
      resp.map(e => {
        e.start = new Date(e.start)
        if (e.end) {
          e.end = new Date(e.end)
        }
        var idx = this.callUsers.findIndex(f => f.id === e.userId)
        e.userName = idx > -1 ? this.callUsers[idx].name : ''
        return 0
      })
      resp.sort((a, b) => a.start > b.start ? 1 : -1)
      this.callHistory = resp
      setTimeout(e => {
        this.scrollToLastHistory()
      }, 1000)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get call history.',
        canCancel: false
      })
    }
  }

  /* async getCallUsers () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getCallUsers/${this.callId}`))
      this.callUsers = resp
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get call users.',
        canCancel: false
      })
    }
  } */

  async getCallData () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getCallData/${this.callId}`))
      this.callData = resp
      this.processedComplete = resp.processedComplete
      this.callUsers = resp.users
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get call data.',
        canCancel: false
      })
    }
  }

  async processingIntervalLogic () {
    this.getCallData()
    this.getCallHistory()
  }

  async requestCallProcessing () {
    this.requestProcessingInterval = setInterval(this.processingIntervalLogic, 5000)
    this.isLoadingProcessing = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/processCall/${this.callId}`))
      this.isLoadingProcessing = false
      if (this.requestProcessingInterval) {
        clearInterval(this.requestProcessingInterval)
        this.requestProcessingInterval = null
        await this.processingIntervalLogic()
      }
    } catch (e) {
      this.isLoadingProcessing = false
      if (this.requestProcessingInterval) {
        clearInterval(this.requestProcessingInterval)
        this.requestProcessingInterval = null
        await this.processingIntervalLogic()
      }
      await this.getCallData()
      this.getCallHistory()
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: e,
        canCancel: false
      })
    }
  }

  async scrollToLastHistory () {
    if (this.$refs && this.$refs.chatHistory) {
      var item = this.$refs.chatHistory.lastElementChild
      if (item) {
        item.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }
}
